import { useEffect } from 'react';

/**
 * SEO Helper Component for Dynamic Meta Tags
 * Optimized for Google Ads conversion tracking
 */
export const SEOHelmet = ({ 
  title, 
  description, 
  keywords, 
  path = '/',
  image = 'https://customer-assets.emergentagent.com/job_couples-calendar-3/artifacts/dg5vfjd3_Ads%C4%B1z%20tasar%C4%B1m%20%2823%29.png'
}) => {
  useEffect(() => {
    // Update title
    document.title = title;

    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }

    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywords || '');
    }

    // Update Open Graph tags
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', title);
    }

    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', description);
    }

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      const baseUrl = process.env.REACT_APP_BACKEND_URL?.replace('/api', '') || window.location.origin;
      ogUrl.setAttribute('content', `${baseUrl}${path}`);
    }

    let ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage) {
      ogImage.setAttribute('content', image);
    }

    // Update Twitter Card tags
    let twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', title);
    }

    let twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', description);
    }

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      const baseUrl = process.env.REACT_APP_BACKEND_URL?.replace('/api', '') || window.location.origin;
      canonical.setAttribute('href', `${baseUrl}${path}`);
    }
  }, [title, description, keywords, path, image]);

  return null;
};

// SEO Configuration for each page
export const SEO_CONFIG = {
  home: {
    title: 'Remindora - Özel Günler Takvimi | Sevdiklerinizle Anılar Oluşturun',
    description: 'Sevdiklerinizle özel günlerinizi asla kaçırmayın! Remindora ile yıldönümlerini, doğum günlerini ve önemli tarihleri hatırlayın. AI destekli hatırlatmalar ve önerilerle unutulmaz anlar yaratın.',
    keywords: 'özel günler, yıldönümü takvibi, doğum günü hatırlatıcısı, çift takvimi, anımsatıcı, sevgililer günü, evlilik yıldönümü, AI hatırlatma',
    url: process.env.REACT_APP_BACKEND_URL?.replace('/api', '') || 'https://date-tracker-24.preview.emergentagent.com',
    path: '/'
  },
  auth: {
    title: 'Kayıt Ol - Remindora | Ücretsiz Yıldönümü Hatırlatıcı',
    description: '✨ Remindora\'ya ücretsiz kayıt olun! Yıldönümü, doğum günü ve özel günleriniz için AI destekli hatırlatmalar ve hediye önerileri. Hemen başlayın!',
    keywords: 'remindora kayıt, ücretsiz hatırlatıcı, çift uygulaması kayıt, yıldönümü uygulama kayıt, özel gün takip kayıt',
    path: '/auth'
  },
  dashboard: {
    title: 'Dashboard - Özel Günlerim | Remindora',
    description: 'Remindora dashboard\'unuzda tüm özel günlerinizi görün, AI asistanından hediye önerileri alın, hazırlık kontrol listenizi yönetin.',
    keywords: 'özel günler dashboard, yıldönümü takip, hediye önerileri, AI asistan, çift takvimi',
    path: '/dashboard'
  },
  profile: {
    title: 'Profil Ayarları - Remindora | Kişiselleştirin',
    description: 'Remindora profilinizi kişiselleştirin. İlgi alanlarınızı, tercihleri ve yaşam tarzınızı ekleyerek daha iyi AI önerileri alın.',
    keywords: 'remindora profil, kişiselleştirme, AI öneriler, çift profili, ilgi alanları',
    path: '/profile'
  },
  feedback: {
    title: 'Geribildirim - Remindora | Görüş ve Önerileriniz',
    description: 'Remindora hakkındaki görüş, öneri ve şikayetlerinizi bizimle paylaşın. Geribildirminiz bizim için değerlidir.',
    keywords: 'remindora geribildirim, öneri, şikayet, destek, iletişim',
    path: '/geribildirim'
  }
};
